import React from "react";
import { Link } from "react-router-dom";
import { Wrench, Truck, Search, ShieldCheck, Boxes, Headset, ArrowRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const SERVICES = [
  { icon: Search, title: "Part Identification", text: "Can't find a part number? Our team helps you identify the exact replacement part from your equipment model." },
  { icon: Boxes, title: "Extensive Catalogue", text: "Thousands of replacement parts for ovens, plumbing, coffee machines, dishwashing, beverage and water filtration equipment." },
  { icon: Truck, title: "Fast Fulfilment", text: "We prioritise uptime. Quick processing and shipping so your kitchen keeps running with minimal downtime." },
  { icon: ShieldCheck, title: "OEM & Approved Parts", text: "Genuine and approved-vendor parts from trusted manufacturers, so every component meets specification." },
  { icon: Headset, title: "Technical Support", text: "Talk to specialists who understand commercial equipment and can guide you to the right solution." },
  { icon: Wrench, title: "Quotes & Bulk Orders", text: "Request quotes for any part, place purchase orders and set up recurring stock for your fleet of equipment." },
];

const Services = () => (
  <div className="min-h-screen flex flex-col bg-white"><Navbar />
    <section className="bg-graphite text-white py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="mono text-xs uppercase tracking-[0.2em] text-orange mb-3">Our Services</div>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">Keeping your kitchen running.</h1>
        <p className="text-white/70 mt-4 max-w-2xl text-lg">From part identification to fast fulfilment, GOT PARTS is your single source for commercial restaurant equipment replacement parts.</p>
      </div>
    </section>
    <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {SERVICES.map((s) => (
        <div key={s.title} className="border border-border rounded-lg p-6 hover:border-orange transition-colors">
          <div className="w-11 h-11 rounded-md bg-orange/10 grid place-items-center mb-4"><s.icon className="w-5 h-5 text-orange" /></div>
          <h3 className="font-semibold text-graphite text-lg">{s.title}</h3>
          <p className="text-sm text-steel-light mt-2 leading-relaxed">{s.text}</p>
        </div>
      ))}
    </section>
    <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-16">
      <div className="bg-surface border border-border rounded-lg p-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div><h3 className="text-xl font-bold text-graphite">Need a part fast?</h3><p className="text-steel-light text-sm mt-1">Search the catalogue or request a quote in seconds.</p></div>
        <Link to="/catalogue" className="inline-flex items-center gap-2 bg-orange hover:bg-orange-hover text-white font-medium rounded-md px-5 h-11">Browse Catalogue <ArrowRight className="w-4 h-4" /></Link>
      </div>
    </section>
    <Footer />
  </div>
);

export default Services;
